import apiClient from "./apiClient";

/**
 * Fetch all Clients
 */
export const getClients = async (companyCode, params = {}) => {
  try {
    const res = await apiClient.get("/api/clients", {
      params: { companyCode, ...params },
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (err) {
    console.error("[ClientService] getClients error:", err);
    return { success: false, clients: [], items: [], message: err.message };
  }
};

/**
 * Create / Onboard Client
 */
export const createClient = async (companyCode, payload) => {
  try {
    const res = await apiClient.post(
      "/api/clients",
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return res;
  } catch (err) {
    console.error("[ClientService] createClient error:", err);
    return { success: false, message: err.message };
  }
};

/**
 * Update Client by ID
 */
export const updateClient = async (companyCode, clientId, payload) => {
  try {
    const res = await apiClient.put(
      `/api/clients/${clientId}`,
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return res;
  } catch (err) {
    console.error("[ClientService] updateClient error:", err);
    return { success: false, message: err.message };
  }
};

/**
 * Get Full Client Profile
 */
export const getClientProfile = async (companyCode, clientId) => {
  try {
    const res = await apiClient.get(`/api/clients/${companyCode}/profile/${clientId}`, {
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (err) {
    console.error("[ClientService] getClientProfile error:", err);
    return { success: false, message: err.message };
  }
};
